module.exports = __webpack_public_path__ + "d012e2e7095307077ef13d5135fc290d.svg";